import { Outlet, useLocation } from "react-router-dom";
import { useEffect } from "react";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import CookieBanner from "@/components/CookieBanner";

const PAGE_META = {
  "/": {
    title: "DROSUN EUROPE — Progettazione e Produzione di Prodotti in Plastica, Metallo e Stampi",
    description: "Drosun Europe: progettazione, sviluppo stampi, produzione e assemblaggio industriale di prodotti in plastica e metallo.",
  },
  "/servizi": {
    title: "Servizi di Progettazione, Produzione e Assemblaggio Industriale | DROSUN EUROPE",
    description: "Stampaggio plastica, lavorazioni CNC, produzione componenti, assemblaggio industriale e soluzioni OEM/ODM.",
  },
  "/prodotti/componenti-arredamento": {
    title: "Componenti e Prodotti per Arredamento | Drosun Europe",
    description: "Drosun Europe progetta e realizza componenti tecnici, prodotti completi e accessori per il settore arredamento, interior design e infissi con produzione industriale su misura.",
  },
  "/prodotti/componenti-nautica": {
    title: "Componenti e Sistemi per la Nautica | Drosun Europe",
    description: "Drosun Europe progetta e realizza componenti tecnici, sistemi e prodotti completi per il settore navale e della nautica da diporto con produzione industriale conto terzi.",
  },
  "/prodotti/packaging-cosmetico": {
    title: "Packaging Cosmetico Personalizzato | Drosun Europe",
    description: "Drosun Europe progetta e realizza packaging cosmetico personalizzato, componenti tecnici e sistemi completi per il settore beauty e profumeria con produzione industriale conto terzi.",
  },
  "/prodotti/food-packaging-pet": {
    title: "Packaging Alimentare PET | Vaschette Termoformate | Drosun Europe",
    description: "Drosun Europe progetta e produce packaging alimentare in PET, vaschette termoformate e contenitori per GDO e Food Service con produzione industriale conto terzi.",
  },
  "/contatti": {
    title: "Contatti | DROSUN EUROPE",
    description: "Contatta Drosun Europe per engineering, produzione industriale, componenti tecnici e packaging conto terzi.",
  },
  "/privacy": { title: "Privacy Policy | DROSUN EUROPE", description: "Informativa sulla privacy del sito Drosun Europe." },
  "/cookie": { title: "Cookie Policy | DROSUN EUROPE", description: "Informativa sui cookie del sito Drosun Europe." },
};

export default function Layout() {
  const { pathname } = useLocation();
  useEffect(() => { window.scrollTo({ top: 0, behavior: "instant" }); }, [pathname]);
  useEffect(() => {
    const meta = PAGE_META[pathname] || PAGE_META["/"];
    document.title = meta.title;
    let tag = document.querySelector('meta[name="description"]');
    if (!tag) {
      tag = document.createElement("meta");
      tag.setAttribute("name", "description");
      document.head.appendChild(tag);
    }
    tag.setAttribute("content", meta.description);
  }, [pathname]);

  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Navbar />
      <main className="flex-1 pt-[96px] lg:pt-[104px]"><Outlet /></main>
      <Footer />
      <CookieBanner />
    </div>
  );
}
